import React, { useRef, useState, useEffect } from "react";
import { ARFormLabel } from "./ARFormLabel";
import { ARHiddenColumnsFilter } from "./ARHiddenColumnsFilter";
import { ComplexParam } from "../../../../../MnJsPlatform.UI.Components/lib/common/ComplexParam";
import { useDispatch, useSelector } from "react-redux";
import { ScreenFormatContext } from "@mnjsplatform/data";
import { ExpandLink } from "./ExpandLink";
import { TabNumberSwitcher } from "./TabNumberSwitcher";
import { leftMenuHide } from "../../../actions/LeftMenuActions";
import classes from "../AnnualRemuneration.module.css";
import ReportPlaceholder from "../../Common/ReportPlaceholder";
import i18next from "i18next";


const Filter = ({h, fieldName, isDesktop, style = {}}) => {
  return (
    <div className={`mr-2 mb-2${!isDesktop ? " w-100" : ""}`} style={style}>
      <div className={"nowrap"}>{h.lbl(fieldName)}</div>
      <div>{h.ed(fieldName)}</div>
    </div>
  );
}

const FilterCheckbox = ({h, fieldName}) => {
  return (
    <div className={'nowrap mr-2 mb-2'}>
      {h.ed(fieldName, { forId: fieldName, style: { 'cursor': 'pointer' } })}&nbsp;
      <label className={'c-pointer'} htmlFor={fieldName}>{h.lbl(fieldName)}</label>
    </div>
  );
}

const ARFiltersContainer = ({pageProps, hiddenColumnsInfo, gridHiddenColumns, toggleHiddenColumns, onChangeTabNumber, onChangeFilters, renderReport, children, isDesktop}) => {

  const dispatch = useDispatch();

  const [listForBossPO, listForBossPOParams] = useSelector(({annualRemunerationReducer}) =>
    [annualRemunerationReducer.SalaryChangeData_ListForBossPO, annualRemunerationReducer.SalaryChangeData_ListForBossPOParams]
  );

  const [filtersVisibility, setFiltersVisibility] = useState(false);
  const [tabNumberChecked, setTabNumberChecked] = useState(false);

  const baseContainerClass = `d-flex flex-wrap ${isDesktop ? 'justify-content-between' : 'flex-column'}`;

  useEffect(() => {
      dispatch(leftMenuHide());
  }, [isDesktop])

  const toggleFiltersVisability = (e) => {
    e && e.preventDefault();
    setFiltersVisibility(!filtersVisibility);
  }

  const renderYearFilter = (h) => {
    const fieldName = 'SalaryChangeLabel';
    return (
      <div>
        <div style={{fontSize: "12px"}}>{h.lbl(fieldName)}</div>
        {h.ed(fieldName)}
      </div>
    );
  }

  const renderFilters = (h) => {
    return (
      <>

        <div className={`d-flex flex-${isDesktop ? 'row' : 'column'} ml-4 mr-4`}>

          <div style={{width: '280px'}} className={"mb-2"}>
            <div>{h.lbl("ViewableData")}</div>
            <ARHiddenColumnsFilter toggleHiddenColumns={toggleHiddenColumns} hiddenColumnsInfo={hiddenColumnsInfo} gridHiddenColumns={gridHiddenColumns} />
          </div>

          <div className={"d-flex flex-column"}>
            <div className={"d-flex flex-wrap w-100"}>
                <Filter h={h} fieldName={'SetAdmStructLabel'} isDesktop={isDesktop} />
                <Filter h={h} fieldName={'FromText'} isDesktop={isDesktop} />
                <Filter h={h} fieldName={"SetDirectWorkLabel"} isDesktop={isDesktop} />
                <Filter h={h} fieldName={"ProfessionLabel"} isDesktop={isDesktop} style={isDesktop ? {"minWidth": "300px"} : {}} />
            </div>
            <div className={"d-flex flex-wrap"}>
                <FilterCheckbox h={h} fieldName={'IsInclSubAS'} />
                <FilterCheckbox h={h} fieldName={'IsOnlyDirectSubBoss'} />
            </div>
          </div>
        </div>
      </>
    );
  }

  const applyFilters = async (rowIndex, { Name, Value }, forceApplyParams) => {
    onChangeFilters();
  }

  const tabNumberCheck = ({tabNumber, checked}) => {
    setTabNumberChecked(checked);
    onChangeTabNumber(tabNumber);
  }

  const columnWarningText = !filtersVisibility && i18next.t("ARFilters_1") || "";
  const filterText = `${filtersVisibility ? i18next.t("Close") : i18next.t("Open")} ${i18next.t("Filters").toLocaleLowerCase()}`;

  return (
    <>
      <div className={`${classes.headerIcons} d-flex flex-wrap justify-content-end w-100 position-absolute`}>
        <ReportPlaceholder reportKey={pageProps.VisualizeReportScId} reportId={pageProps.VisualizeReportScId} showLabelOnLoading={false}>
          {(reportParamsItem, build) => <i className="zmdi zmdi-file-text" onClick={(e) => renderReport(e, reportParamsItem, build)} />}
        </ReportPlaceholder>
        <div className={"gap"}/>
      </div>
      <div className={`d-flex flex-wrap m-2 ml-4`}>

        <div className={"ml-2 mb-auto mt-auto"}>
          <h2 className={"placeholder-wrapper-title show m-0"}>{i18next.t('ChangeSalaryEmployees')}</h2>
        </div>

        <div className={"mt-auto ml-2 mb-2"}>
          <ComplexParam dataItem={listForBossPOParams} renderParams={renderYearFilter} dispatch={dispatch} parentDataItem={listForBossPO} />
        </div>

        <div className={"d-flex mt-auto ml-2 mb-2"} style={{ width: "350px" }}>
          {!!pageProps.ToAllowSet_TestTabNum &&
            <TabNumberSwitcher onChange={tabNumberCheck} checked={tabNumberChecked} />
          }
        </div>
      <div/>

      </div>
      {filtersVisibility &&
          <ComplexParam dataItem={listForBossPOParams} renderParams={renderFilters} onEndEditField={applyFilters}/>
      }
      {isDesktop &&
        <div className={`${baseContainerClass} mb-2`}>
          <div className={`${!isDesktop && 'order-1 ' || ''}ml-4`}>{columnWarningText}</div>
          <ARFormLabel text={pageProps.Label_MainForm}/>
          <div className={'d-inline-flex'}>
            {children}
            <ExpandLink className={"ml-4 mr-4 mt-1"} isOpen={filtersVisibility} clickHandler={toggleFiltersVisability} title={filterText} />
          </div>
        </div>
      }
      {!isDesktop &&
        <div className={`d-flex flex-wrap flex-column m-1 mr-4 ml-4`}>
          <ARFormLabel text={pageProps.Label_MainForm}/>
          <div className={"d-flex flex-row mt-1"}>
            <div className={"ml-1"}>{columnWarningText}</div>
            <ExpandLink className={"mr-1 ml-auto"} isOpen={filtersVisibility} clickHandler={toggleFiltersVisability} title={filterText} />
          </div>
          <div>{children}</div>
        </div>
      }
    </>
  );
};

const ARFilters = (props) => (
  <ScreenFormatContext.Consumer>
    { isDesktop => <ARFiltersContainer {...props} isDesktop={isDesktop} />}
  </ScreenFormatContext.Consumer>
)

export { ARFilters };